import { useState, useEffect } from 'react';
import api, { uploadsApiPath } from '../utils/api';

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(r.result);
    r.onerror = () => reject(new Error('read failed'));
    r.readAsDataURL(blob);
  });
}

/**
 * Fetches a protected /api/uploads file with auth and exposes a data: URL for <img src>.
 * Uses data URLs (not blob:) so images work under Helmet CSP img-src 'self' data: without needing blob:.
 */
export function useUploadBlobUrl(filename) {
  const [state, setState] = useState({
    url: null,
    loading: false,
    error: false,
  });

  useEffect(() => {
    if (!filename) {
      setState({ url: null, loading: false, error: false });
      return;
    }
    const path = uploadsApiPath(filename);
    if (!path) {
      setState({ url: null, loading: false, error: true });
      return;
    }

    let cancelled = false;

    setState({ url: null, loading: true, error: false });

    api
      .get(path, { responseType: 'blob' })
      .then(async (res) => {
        if (cancelled || !res.data) return;
        const blob = res.data;
        const ct = String((res.headers && res.headers['content-type']) || blob.type || '');
        if (/application\/json|text\/html/i.test(ct)) {
          throw new Error('not an image');
        }
        const dataUrl = await blobToDataUrl(blob);
        if (!cancelled) setState({ url: dataUrl, loading: false, error: false });
      })
      .catch(() => {
        if (!cancelled) setState({ url: null, loading: false, error: true });
      });

    return () => {
      cancelled = true;
    };
  }, [filename]);

  return state;
}
